import { createContext } from "react";

/** Context carrying live-typed (draft) values so total cells re-render on every
 *  keystroke without putting draftValues in the columns useMemo deps. */
export const BoQDraftContext = createContext({
	values: {},
	editingRowId: null,
});

/**
 * BoQ row shape (tree node; has optional children).
 * Field names mirror AVA Cloud PositionDto keys to minimise adapter transformation.
 */
export const getDefaultBoQRow = (overrides = {}) => ({
	id: "",
	type: null,
	itemNumber: "",
	shortText: "",
	longText: "",
	quantity: null,
	unitTag: "",
	unitPrice: null,
	/** AVA-computed net total (qty × price). null for new rows until first save. */
	totalPrice: null,
	/** taxRate as decimal (0.19 = 19 %), matching AVA taxRate field. */
	taxRate: null,
	/** AVA-computed gross total (totalPrice × (1 + taxRate)). null until first save. */
	totalPriceGross: null,
	costGroupId: null,
	children: [],
	...overrides,
});
